<!-- @format -->

<ng-container *transloco="let t">
  <div id="student-application" class="student-application create-extension-application">
    @if (planData() && automaticallyFilledApplicationFields() && universitySettings$ | async; as settings) {
      @if (settings.featureToggles?.studyRightExtensionFeeEnabled && currentStep() !== "payerDetails") {
        <fudis-body-text class="fudis-mb-lg" [variant]="'lg-light'">
          <transloco
            key="PROFILE.APPLICATIONS.EXTENSION_APPLICATION.IS_CHARGEABLE_DESCRIPTION"
            [params]="{ price: settings.studyRightExtensionPaymentConfiguration?.price | money }">
          </transloco>
          @if (settings.studyRightExtensionPaymentConfiguration?.instructionsUrl | localizedString; as instructionsUrl) {
            <!-- Prevents the link from being appended directly to the last word in the preceding text -->
            {{ " " }}
            <a
              fudisLink
              [title]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.FROM_UNIVERSITY_SITE')"
              [external]="true"
              [href]="instructionsUrl"></a>
          } @else {
            {{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.FROM_UNIVERSITY_SITE") }}.
          }
        </fudis-body-text>
      }
      <app-study-right-extension-application-form
        [hidden]="currentStep() !== 'application'"
        [planData]="planData()"
        [automaticallyFilledApplicationFields]="automaticallyFilledApplicationFields()"
        [continueLabel]="t(settings.featureToggles?.studyRightExtensionFeeEnabled ? 'BUTTON.PREVIEW' : 'STUDENT_APPLICATIONS.SEND')"
        (edited)="hasUnsavedChanges = $event"
        (continue)="onApplicationFormContinue($event, settings.featureToggles?.studyRightExtensionFeeEnabled)"
        (exit)="exitApplication()" />

      @if (settings.featureToggles?.studyRightExtensionFeeEnabled) {
        @if (filledExtensionApplication()) {
          <app-study-right-extension-application-preview
            [hidden]="currentStep() !== 'preview'"
            [planData]="planData()"
            [filledExtensionApplication]="filledExtensionApplication()"
            (continue)="onStepChange('payerDetails')"
            (previous)="onStepChange('application')" />
        }

        <app-study-right-extension-application-payer-details
          [hidden]="currentStep() !== 'payerDetails'"
          (continue)="submitPaidApplication($event)"
          (previous)="onStepChange('preview')" />
      }
    }
  </div>
</ng-container>
